
export const sortServices = (services = []) => {
  return [...services].sort((a, b) => {

    if (a.status === "changed" && b.status !== "changed") {
      return -1;
    }

    if (a.status !== "changed" && b.status === "changed") {
      return 1;
    }

    const dayA = a.timeline?.dayNumber || 1;
    const dayB = b.timeline?.dayNumber || 1;

    if (dayA !== dayB) {
      return dayA - dayB;
    }

    const orderA = a.timeline?.order || 0;
    const orderB = b.timeline?.order || 0;

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
  });
};


export const mergeServiceUpdate = (prev, updatedService) => {
  const next = prev.map((s) =>
    s._id === updatedService._id
      ? {
          ...s,
          ...updatedService,
        }
      : s
  );

  return sortServices(next);
};

export const removeServiceLocally = (prev, serviceId) => {
  return prev.filter((s) => s._id !== serviceId);
};

export const reorderServicesLocally = (prev, updates) => {
  const map = new Map();

  updates.forEach((u) => {
    map.set(String(u.serviceId), u);
  });

  const next = prev.map((s) => {
    const update = map.get(String(s._id));

    if (!update) return s;

    return {
      ...s,
      timeline: {
        ...s.timeline,
        dayNumber: update.dayNumber ?? 1,
        order: update.order ?? 0,
      },
    };
  });

  return sortServices(next);
};
